import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { routePrefix, routes } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import Spinner from './Components/spinner';
import NoProducts from './Components/noProduct';
import { TbArrowNarrowRight } from 'react-icons/tb';

const AllCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = useSelector(
    (state: RootState) => state.common.activeCustomerTab
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getData(`categories?type=service`);
        if (response.status === 200 || response.status === 201) {
          setCategories(response?.data?.data?.all_categories);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="page-title">{activeTab}</h1>
              <ul>
                <li>
                  <Link to={routes.home}>Dashboard</Link>
                </li>
                <li className="active">
                  {activeTab
                    .split('-')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <section className="product-tab-section mt-3">
          {categories?.length > 0 ? (
            categories?.map((category: any) => (
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-hdr d-flex align-items-center justify-content-between">
                      <h3>
                        <Link
                          to={`${routePrefix}/category/${category?.id}`}
                          onClick={() => {
                            dispatch(setActiveCustomerTab(category.name));
                          }}
                        >
                          {category?.name}
                        </Link>
                      </h3>
                      <Link
                        to={`${routePrefix}/category/${category?.id}`}
                        onClick={() => {
                          dispatch(setActiveCustomerTab(category.name));
                        }}
                        className="va-link"
                      >
                        View All
                        <TbArrowNarrowRight size={16} />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="allproduct-grid mb-2 mb-md-4 row">
                  <div className="col-sm-2 text-center">
                    <div className="category-container">
                      <Link
                        to={`${routePrefix}/category/${category?.id}`}
                        onClick={() => {
                          dispatch(setActiveCustomerTab(category.name));
                        }}
                      >
                        <div className="category-container-img">
                          <img
                            loading="lazy"
                            className="category-img"
                            src={`${category?.image_path}${category?.image}`}
                            alt={category?.slug}
                          />
                        </div>
                        <div className="category-name">{category?.name}</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <NoProducts />
          )}
        </section>
      )}
    </>
  );
};

export default AllCategory;
